"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FittecWrappedModule = void 0;
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var helper_const_1 = require("@src/const/helper.const");
var cash_dom_1 = __importDefault(require("cash-dom"));
var lodash_1 = require("lodash");
var self_service_helper_1 = require("../self-service.helper");
var ci_component_injector_service_1 = require("@src/services/ci-component-injector.service");
var fittec_wrapped_stories_const_1 = require("./fittec-wrapped-stories.const");
var FittecWrappedModule = /** @class */ (function () {
    function FittecWrappedModule() {
    }
    FittecWrappedModule.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var selfServiceData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, generator_const_1._HideErrorMessage)();
                        selfServiceData = (0, self_service_helper_1.loadSelfServiceToken)();
                        if (!selfServiceData)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.loadUsersWrapData()];
                    case 1:
                        _a.sent();
                        this.ensureWrappedCards();
                        this.fillWrappedPlaceholders();
                        (0, ci_component_injector_service_1._InjectStencilWebComponents)();
                        return [2 /*return*/];
                }
            });
        });
    };
    FittecWrappedModule.prototype.loadUsersWrapData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                /** TBD use the real HTTP JSON */
                this.userData = {
                    year: 2026,
                    companyName: 'Fitness First',
                    checkins: 168,
                    averageTrainingDurationMinutes: 75,
                    courseVisitsByCategory: [
                        { category: 'Kraft', visits: 32 },
                        { category: 'Cycling', visits: 24 },
                        { category: 'Yoga', visits: 18 },
                        { category: 'Pilates', visits: 12 },
                    ],
                    favoriteCourse: { name: 'Body Workout', visits: 32 },
                    topPercentInClub: 0.08,
                    topPercentInCompany: 0.12,
                };
                return [2 /*return*/];
            });
        });
    };
    FittecWrappedModule.prototype.ensureWrappedCards = function () {
        var _a, _b;
        var containers = this.$container.is('ci-story-cards')
            ? this.$container
            : (0, helper_const_1._GetElementInModule)(this.$container, 'ci-story-cards');
        if (!containers.length) {
            var reference = (_b = (_a = this.module.references) === null || _a === void 0 ? void 0 : _a.fittecWrappedContainer) === null || _b === void 0 ? void 0 : _b.domElement;
            containers = (0, cash_dom_1.default)(document.createElement('ci-story-cards')).attr('is-open', '').attr('show-share', '');
            ((reference === null || reference === void 0 ? void 0 : reference.length) ? reference : this.$container).append(containers);
        }
        containers.each(function (_, element) {
            var _a;
            if (element.children.length || ((_a = element.textContent) === null || _a === void 0 ? void 0 : _a.trim()))
                return;
            element.innerHTML = fittec_wrapped_stories_const_1._FittecWrappedDefaultStories.join('');
        });
    };
    FittecWrappedModule.prototype.fillWrappedPlaceholders = function () {
        if (!this.userData)
            return;
        var numberFormatter = new Intl.NumberFormat('de-DE');
        var percentFormatter = new Intl.NumberFormat('de-DE', {
            style: 'percent',
            maximumFractionDigits: 0,
        });
        var userData = this.userData;
        var minutesSpent = userData.checkins * userData.averageTrainingDurationMinutes;
        var values = __assign(__assign({}, userData), { year: String(userData.year), minutesSpent: minutesSpent, hoursSpent: Math.round(minutesSpent / 60), courseCategoryCount: userData.courseVisitsByCategory.length, courseVisits: userData.courseVisitsByCategory.reduce(function (total, course) { return total + course.visits; }, 0), topPercentInClub: percentFormatter.format(userData.topPercentInClub), topPercentInCompany: percentFormatter.format(userData.topPercentInCompany) });
        (0, helper_const_1._GetElementInModule)(this.$container, '[data-get]').each(function (_, element) {
            var key = element.getAttribute('data-get');
            if (!key)
                return;
            var value = (0, lodash_1.get)(values, key);
            if (typeof value === 'number') {
                element.textContent = numberFormatter.format(value);
            }
            else if (typeof value === 'string') {
                element.textContent = value;
            }
        });
    };
    return FittecWrappedModule;
}());
exports.FittecWrappedModule = FittecWrappedModule;
